import React from 'react';
import './Home.css';

class Home extends React.Component {
  render() {
    return (
      <div className="app home">
        <h1 className="app-heading home-heading color-indigo">Front End Developer &amp; UI/UX Designer</h1>
        <p className="app-paragraph home-paragraph">
          <a href="mailto:w3debugger@gmail.com">w3debugger@gmail.com</a>
          {/*
          <span> / </span>
          <a href="tel:+971529951559">+971 52 995 1559</a>
          */}
        </p>

        <p className="app-paragraph home-paragraph">It's me Muhammad Umar from Pakistan, having more than {(new Date().getFullYear()) - 2010} years of experience in UX/UI Web Designer / Developer &amp; Frontend Developer. Currently working as Visual Web Developer / Frontend Developer at Al Tayer Group. </p>

        <p className="app-paragraph home-paragraph">Studied GW Basics &amp; basic Turbo C++ in college. Started professional life's first 2.5 years as a UX/UI Web Designer &amp; Interactive Designer to know the psychology of people's behavior &amp; emotions. Then learned and worked as a UX/UI Web Developer &amp; Frontend Developer to make Static / Interactive Designs work in browsers. Trying to grasp on Core JavaScript. Love Family, gaming, music, deep movies &amp; quotes, cultures, people &amp; society :)</p>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Pages/Home.js